import { CartItemViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { EJRecordTypes } from '../enumerations/ej-record-types';
import { IElectronicJournalRecord } from '../interfaces/states/IElectronicJournalRecord';
import { store } from '../redux/configure-store';

export const getEJItemBySequenceNumber = (
  sequenceNumber: number,
): IElectronicJournalRecord | undefined => {
  return store
    .getState()
    .itemList.ejItems.find(
      (item: IElectronicJournalRecord) =>
        item.SequenceNumber === sequenceNumber && item.Type === EJRecordTypes.Product,
    );
};

export const getItemByLineId = (lineId: number): CartItemViewData | undefined => {
  return store.getState().itemList.items?.find((item: CartItemViewData) => item.lineId === lineId);
};
